import { render, staticRenderFns } from "./GroupMemberSelector.vue?vue&type=template&id=2ed4c206&scoped=true"
import script from "./GroupMemberSelector.vue?vue&type=script&lang=js"
export * from "./GroupMemberSelector.vue?vue&type=script&lang=js"
import style0 from "./GroupMemberSelector.vue?vue&type=style&index=0&id=2ed4c206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../lianqiao-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed4c206",
  null
  
)

export default component.exports